module.exports = __webpack_public_path__ + "img/abudhabi-25.f2cf081f.png";